import { render, staticRenderFns } from "./RouteTask.vue?vue&type=template&id=01780b80&scoped=true"
import script from "./RouteTask.vue?vue&type=script&lang=js"
export * from "./RouteTask.vue?vue&type=script&lang=js"
import style0 from "./RouteTask.vue?vue&type=style&index=0&id=01780b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01780b80",
  null
  
)

export default component.exports